'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.buildThumbnailUrl = buildThumbnailUrl;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ConfigStore = require('./ConfigStore');

var _ConfigStore2 = _interopRequireDefault(_ConfigStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var btoa = window.btoa;

function buildThumbnailUrl() {
  var imageUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$width = options.width,
      width = _options$width === undefined ? 1200 : _options$width,
      _options$height = options.height,
      height = _options$height === undefined ? 1200 : _options$height,
      exact = options.exact,
      preserve = options.preserve;


  if (!imageUrl || imageUrl.match(/cloudfront\.net/) || imageUrl.match(/^\/[^/]/)) {
    return imageUrl;
  }

  var authDomain = _ConfigStore2.default.getConfig('auth_domain');

  var url = 'https://dlqxt4mfnxo6k.cloudfront.net/';
  url += authDomain + '/';
  url += btoa(encodeURI(decodeURIComponent(imageUrl))).replace('/', '-') + '/';
  url += '' + (preserve ? 'preserve/' : '');
  url += '' + (exact ? 'exact/' : '');
  url += width + '/' + height;

  return url;
}

function Image(props) {
  var src = props.src,
      alt = props.alt,
      style = props.style,
      width = props.width,
      height = props.height,
      exact = props.exact,
      preserve = props.preserve,
      applySize = props.applySize,
      imageProps = (0, _objectWithoutProperties3.default)(props, ['src', 'alt', 'style', 'width', 'height', 'exact', 'preserve', 'applySize']);


  if (exact && applySize) {
    imageProps.height = height;
    imageProps.width = width;
  }

  return _react2.default.createElement('img', (0, _assign2.default)({ src: buildThumbnailUrl(src, props), alt: alt, style: (0, _extends3.default)({}, style) }, imageProps));
}

Image.propTypes = {
  applySize: _propTypes2.default.bool,
  src: _propTypes2.default.string.isRequired,
  alt: _propTypes2.default.string.isRequired,
  width: _propTypes2.default.number,
  height: _propTypes2.default.number,
  exact: _propTypes2.default.bool,
  preserve: _propTypes2.default.bool,
  style: _propTypes2.default.object
};

Image.defaultProps = {
  applySize: false,
  width: 1200,
  height: 1200,
  exact: false,
  preserve: false,
  style: {}
};

exports.default = Image;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-utilities/build/Image.js
// module id = 1153
// module chunks = 0